"use client";

import React from "react";
import { useGlobalFeatureFlags } from "@/lib/contexts/global-feature-flags-context";
import { getFeatureFlags } from "@/lib/feature-flags";
import { ComingSoon } from "../coming-soon/coming-soon";

type FeatureFlagKeys = keyof ReturnType<typeof getFeatureFlags>;

interface FeatureGateProps {
  feature: FeatureFlagKeys;
  children: React.ReactNode;
  showComingSoon?: boolean;
}

export function FeatureGate({ feature, children, showComingSoon = false }: FeatureGateProps) {
  const { isFeatureEnabled } = useGlobalFeatureFlags();

  if (isFeatureEnabled(feature)) {
    return <>{children}</>;
  }

  return showComingSoon ? <ComingSoon /> : null;
}
